export default "__VITE_ASSET__yzAQHprf__"